import axios from 'axios'
import jwtDecode from 'jwt-decode'
import UrlParams from './components/common/urlParams'
// instantiate axios
const httpClient = axios.create()
httpClient.getToken = function() {
	return localStorage.getItem('token')
}
httpClient.setToken = function(token) {
	localStorage.setItem('token', token)
	return token
}
httpClient.getCurrentUser = function() {
	const token = this.getToken()
	if(token) return jwtDecode(token)
	return null
}

const HOST_NAME= process.env.REACT_APP_SERVER_URL
httpClient.logIn = function(credentials) {
	//am using proxy so the real route is in another port which is 5000
	return this({ method: 'post', url: `${HOST_NAME}/api/users/authenticate`,  headers: {'Content-Type': 'application/x-www-form-urlencoded'},data: credentials })
		.then((serverResponse) => {
			const token = serverResponse.data.token
			if(token) {
				// sets token as an included header for all subsequent api requests
				this.defaults.headers.common.token = this.setToken(token)
				return jwtDecode(token)
			} else {
				return false
			}
		})
}
// logIn and signUp functions could be combined into one since the only difference is the url we're sending a request to..
httpClient.signUp = function(userInfo) {
	return this({ method: 'post', url: `${HOST_NAME}/api/users`, data: userInfo})
		.then((serverResponse) => {
			const token = serverResponse.data.token
			if(token) {
				// sets token as an included header for all subsequent api requests
				this.defaults.headers.common.token = this.setToken(token)
				return jwtDecode(token)
			} else {
				return false
			}
		})
}
httpClient.logOut = function() {
	localStorage.removeItem('token')
	delete this.defaults.headers.common.token
	return true
}
httpClient.getAgentsList = function() {
	return this({ method: 'get', url: `${HOST_NAME}/api/users/assistants`,data:{}})
	.then((serverResponse) => {
		const agentListResponse = serverResponse.data.list
		if(agentListResponse) {
			//get sous-agents List before inisialisé state
			return agentListResponse;
		} else {
			 return {};
		}
	})
}
httpClient.ActiveInactive = function(value,id) {
	return this({ method: 'post', url: `${HOST_NAME}/api/users/list`, data: {value:value,agentId:id}})
	.then((serverResponse) => {
		if (serverResponse.data) {
			const token = serverResponse.data.token
			if(token) {
				// sets token as an included header for all subsequent api requests
				this.defaults.headers.common.token = this.setToken(token)
				return jwtDecode(token)
			} else {
				return false
			}
		}else return false
	})
}
httpClient.DeleteSousAgent = function(id){
	const Id = id
	return this({ method: 'delete', url: `${HOST_NAME}/api/users/${Id}`})
	.then((serverResponse) => {
		if (serverResponse) {
			const token = serverResponse
			if(token) {
				// sets token as an included header for all subsequent api requests
				return console.log("user delete");
			} else {
				return false
			}
		}else return false
	})
}
//create announce
httpClient.createAnnounceHebergement = async function(announceInfo,idOwner,typeAnnounce,files){
	let formData = await new FormData();
	for (let i = 0; i < files.length; i++) {
		 formData.append('myImage[]',files[i],files[i].name);	
	}
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/accommodation`, data: {announceInfo,idOwner,typeAnnounce} })
	.then((response)=>{
		this({ method: 'post', url: `${HOST_NAME}/api/announces/image/accommodation/${response.data}`, data: formData })
		return(response.data);
	})
}
//create announce
httpClient.createCarAnnouce=async function(announceInfo,idOwner,typeAnnounce,files){
	let formData = await new FormData();
	for (let i = 0; i < files.length; i++) {
		 formData.append('myImage[]',files[i],files[i].name);	
	}
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/cars`, data: {announceInfo,idOwner,typeAnnounce} })
	.then((response)=>{
		this({ method: 'post', url: `/api/announces/image/cars/${response.data}`, data: formData })
		return(response.data);
	})
}
httpClient.uploadImagRq = function(file){
	const formData =   new FormData();
    formData.append('myImage',file,file.name);
	return  this({ method: 'post', url: `${HOST_NAME}/api/announces/image`, data: formData })
	.then((response)=>{
		return(response.data);
	})
}
httpClient.uploadFileMessage =async function(file){
	let formData = await new FormData();
		 formData.append('myImage[]',file,file.name);	
	// console.log(file);
	console.log("file");
	// const formData =   new FormData();
    // formData.append('myImage[]',file,file.name);
	return  this({ method: 'post', url: `${HOST_NAME}/api/messages/uploadFiles`, data: formData })
	.then((response)=>{
		return(response.data);
	}).catch(err=>{
		console.log(err);
	})
}
httpClient.postCommentAccommodation = function(cmnt,idAnnounce){
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/comment/accommodation`,data:{cmnt}})
	.then((serverResponse) => {
		if(serverResponse) {
			//hebergement announces after Searching
			return serverResponse.data;
		}
	})
}
httpClient.postCommentCar = function(cmnt,idAnnounce){
	console.log(cmnt);
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/comment/cars`,data:{cmnt}})
	.then((serverResponse) => {
		if(serverResponse) {
			console.log("Accom");
			//hebergement announces after Searching
			return serverResponse.data;
		}
		else console.log(serverResponse);
	}).catch(err=>console.log(err))
}
//get All announces hebergement
httpClient.getAllHebergAnnounces = function(){
	return this({ method: 'GET', url: `${HOST_NAME}/api/announces/accommodation`})
	.then((serverResponse) => {
		if(serverResponse) {
			// all hebergement announces 
			return serverResponse.data;
		} else {
			return false
		}
	})
}
// get user
httpClient.getUser = function(id){
	return this({method : 'GET', url : `${HOST_NAME}/api/users/${id}`})
	.then((serverResponse) => serverResponse ? serverResponse.data : false
	)
}
httpClient.getUserAnnounces = function(id,announceType){
	return this({method : 'GET', url : `${HOST_NAME}/api/users/profile/${announceType}/${id}`})
	.then((serverResponse) => serverResponse ? serverResponse.data : false
	)
}
//get announces Cars Location
httpClient.getAllCarsLocation = function(params){
	let urlParams = new UrlParams(params,0).params
	return this({ method: 'GET', url: `${HOST_NAME}/api/announces/cars/location`,params: urlParams })
	.then((serverResponse) => {
		if(serverResponse) {
			// all cars announces 
			return serverResponse.data;
		} else {
			return false
		}
	})
}
//get announces Cars transfert
httpClient.getAllCarsTransfert= function(params){
	let urlParams = new UrlParams(params,0).params
	return this({ method: 'GET', url: `${HOST_NAME}/api/announces/cars/transfert`,params: urlParams })
	.then((serverResponse) => {
		if(serverResponse) {
			// all cars announces 
			return serverResponse.data;
		} else {
			return false
		}
	})
}
httpClient.getAnnounceDetailRqst = function(idHebergement){
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/acommodation_details`, data:{idHebergement}})
	.then((serverResponse) => {
		if(serverResponse) {
			//hebergement announce detail
			return serverResponse.data;
		} else {
			return false
		}
	})
}
httpClient.getCarDetail = function(carID){
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/car_details`, data:{carID}})
	.then((serverResponse) => {
		if(serverResponse.data) {
			//voiture announce detail
			return serverResponse.data;
		} else {
			return false
		}
	})
}
//hebergement
httpClient.getSearchedAnnounces = function (params) {
	try {
		//0 when all params are strings else there is some params are int and should be parsed
		let urlParams = new UrlParams(params,0).params
		return this({ method: 'get', url: `${HOST_NAME}/api/announces/accommodation/advanced_search`, params: urlParams })
		.then((serverResponse) => {
			if (serverResponse) {
				//hebergement announces after Searching
				return serverResponse.data;
			} else {
				return false
			}
		})
	} catch (error) {
		console.log(error.message);
	}
}
httpClient.addToFav = function (userId , announceId , announceType , title) {
	return this({ method: 'post', url: `${HOST_NAME}/api/favorit/${userId}/${"announceId"}/${announceType}`,data:{title} }).then(res=>{
		console.log(res);
	})
}
httpClient.getFavorits = function (userId) {
	return this({ method: 'get', url: `${HOST_NAME}/api/favorit/${userId}`}).then(res=>{
		return res.data;
	})
}
httpClient.getSearchedVols = function (params,volType){
	try {
		const query = 
		{origin : params.get('depart'),
		destination : params.get('arrive'),
		dateDepart : params.get('date_depart'),
		dateArrive : params.get('date_arrive'),
		rtrn : params.get('return'),
		adults : params.get('adults'),
		children : params.get('children'),
		infants : params.get('infants'),
		price_from : params.get('price_from'),
		price_to : params.get('price_to'),
		adult_hand_bag : params.get('adult_hand_bag'),
		adult_hold_bag : params.get('adult_hold_bag'),
		multi :params.get('multi'),
		vol_class :params.get('vol_class')
	   }
		if (parseInt(query.multi) === 0 || parseInt(query.multi) === -1) {
			return this({ method: 'get', url: `${HOST_NAME}/api/announces/vol`,params:query})
		.then((serverResponse) => {
			if (serverResponse) {
				return serverResponse.data;
			} else {
				return console.log("falssse");
			}
		}).catch(err=>{
			console.log(err);
		})
		}
		else  return this({ method: 'get', url: `${HOST_NAME}/api/announces/vol/multi_city`,params:query})
		.then((serverResponse) => {
			if (serverResponse) {
				return serverResponse.data;
			} else {
				return false
			}
		})
		
	} catch (error) {
		return false
	}
		
}
httpClient.autocompletePlaces = function(keyword){
	return this({ method: 'get', url: `${HOST_NAME}/api/announces/vol/places/search`,params:{keyword:keyword} })
	.then((serverResponse) => {
		if(serverResponse.data.data[0]) {
			//hebergement announces after Searching
			return serverResponse.data;
		} else {
			return false
		}
	})
}
httpClient.getDetailVol = function (token) {
	try {
		return this({ method: 'get', url: `${HOST_NAME}/api/announces/vol/flight/${token}` })
		.then((serverResponse) => {
			if (serverResponse) {
				return serverResponse.data;
			} else {
				return false
			}
		})
	} catch (error) {
		return false
	}
		
}


httpClient.incrVues = function (announceId) {
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/accommodation/vues/inc/`,data:{announceId} }).then(res=>{
		console.log(res);
	})
}

httpClient.changeStatus = function (announceId,value) {
	return this({ method: 'post', url: `${HOST_NAME}/api/announces/accommodation/change_status`,data:{announceId,value} }).then(res=>{
		console.log(res);
	})
}

httpClient.deleteAccomodation = function (announceId) {
	return this({ method: 'delete', url: `${HOST_NAME}/api/announces/accommodation/delete/${announceId}` }).then(res=>{
		console.log(res);
	})
}


// During initial app load attempt to set a localStorage stored token
// as a default header for all api requests.
httpClient.defaults.headers.common.token = httpClient.getToken()
export default httpClient